module.exports = __webpack_public_path__ + "img/gridCard.8691f0db.png";